import { inject, observer } from 'mobx-react';
import { useState, useEffect } from 'react';
import cx from 'classnames';

import useCheckoutStore from 'stores/CheckoutStoreV2';
import Avatar from 'components/Avatar/Avatar';

// Simple email validation function
const isValidEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

const FoundUser = ({ userProfileStore }) => {
  const checkoutStore = useCheckoutStore();
  const [user, setUser] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    // Only fetch user if email is valid
    if (isValidEmail(checkoutStore.email)) {
      userProfileStore
        .getUserByEmail({ email: checkoutStore.email })
        .then(setUser);
    } else {
      setUser(null);
    }
  }, [checkoutStore.email]);

  if (!user) {
    return <></>;
  }

  return (
    <div
      className={cx(
        'h-16 overflow-hidden transition-all my-[11px] font-agenda text-[15px] cursor-pointer border border-solid border-lightgray-c4c rounded-[10px] hover:bg-lightgray-f1f',
        {
          'h-32': isExpanded,
        },
      )}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="flex justify-between w-full h-16 px-2">
        <div className="my-auto leading-tight">
          <div>Login as: </div>
          <div className="font-agenda-bold">
            {user?.firstName} {user?.lastName}
          </div>
        </div>
        <Avatar className="my-auto" avatarUrls={user?.avatarUrls} size={40} />
      </div>
      <div className="px-2 flex">
        <input
          className="mt-1 w-full rounded-lg pl-2 text-[17px] font-agenda border-lightgray-c4c border-solid border-[1px] h-[45px]"
          value=""
          placeholder="Password"
        />
      </div>
    </div>
  );
};

export default inject('userProfileStore')(observer(FoundUser));
